/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

"use strict";

const angular = require("angular");

const EVENT_USERAUTHENTICATED = "oidc_user_authenticated";
const EVENT_USERCHANGED = "oidc_user_changed";

angular
    .module("ROGER")

    //
    .controller("AppController", [
        "$rootScope", "$scope", "$http", "$sessionStorage", "$uibModal", "$messageBox", "$shoppingCart", "$progress", "$notifications", "$oidc", "$user",
        function (rootScope, scope, http, sessionStorage, modal, messageBox, shoppingCart, progress, notifications, oidc, user) {

            // Pokud je obsažen parametr signagain, bylo zvoleno na authorizačním
            // serveru zvoleno sign -in -again, kde se uživatel přihlásí buď znovu nebo pod jiným profilem
            // oidc.signOut() tato metoda vyvolá okno popsané výše
            if (location.href.includes('signagain=true')) {
                oidc.signOut();
            }

            var _retailer = {
                Id: -1,
                TypeId: -1,
                PartnerId: -1,
                RetailerId: -1,
                InvoiceToId: -1,
                DisplayName: "",
                AllowReservation: false,
                AllowOrder: false,
                AllowAvailability: false,
                AllowDelivery: false,
                CountryId: -1,
                DateOfFoundation: "1900-01-01T00:00:00",
                RegionId: -1,
                CustomerDrivenAreaId: -1,
                RetailerLifeCycleId: -1,
                Reservations: 0,
                ShowroomLimit: 0
            };

            // Page title
            scope.pageTitle = "ROGER";

            //
            scope.version = __ROGER__.app.version;

            //
            scope.progress = progress;
            scope.notifications = notifications;

            // Application Insights
            scope.$on('$routeChangeSuccess', function (event, current) {
                if (window.appInsights) {
                    window.appInsights.trackPageView(current);
                }
            });

            // Storage
            scope.$storage = sessionStorage.$default({
                user: {
                    Id: -1,
                    Name: "",
                    FullName: "",
                    Retailer: _retailer,
                    RetailerCode: null,
                    Roles: [],
                    IsOnBehalfOfDealers: false,
                    IsOrderingManager: false,
                    IsOrderingReader: false,
                    IsModelAvailabilityReader: false,
                    IsInvoiceReader: false,
                    IsAuthenticated: false
                },
                retailer: _retailer,
                retailers: [],
                customerView: false,
                shoppingCart: [],
                dashboard: {
                    refreshTime: "900000"
                },
                catalog: {
                    brandId: null,
                    modelId: null,
                    modelTypeId: null,
                    modelGradeId: null,
                    modelColorId: null
                },
                bonusCatalog: {
                    modelNameId: null
                },
                modelBrowser: {
                    orderName: "ModelLineName",
                    orderDesc: false
                },
                modelETABrowser: {
                    orderName: "ModelLineName",
                    orderDesc: false
                },
                bonusCars: {
                    orderName: "ModelLineName",
                    orderDesc: false
                },
                reservations: {
                    orderName: "ModelLineName",
                    orderDesc: false
                },
                salesOrders: {
                    orderName: "CreateDate",
                    orderDesc: true,
                    searchText: "",
                    dateFrom: "",
                    dateTo: "",
                    showClosed: false,
                    showCanceled: false
                },
                salesOrderRequest: {
                    orderName: "DueDate",
                    orderDesc: false,
                    requestTypeId: null
                },
                salesOrderRequestModel: {
                    orderName: "ModelLineName",
                    orderDesc: false,
                    modelId: null,
                    modelTypeId: null,
                    modelGradeId: null,
                    modelColorId: null
                },
                invoices: {
                    orderName: "CreateDate",
                    orderDesc: true,
                    searchText: "",
                    dateFrom: "",
                    dateTo: "",
                    showProcessed: false
                },
                carsToRetail: {
                    orderName: "RetailDate",
                    orderDesc: false
                },
                retails: {
                    orderName: "RetailDate",
                    orderDesc: false
                },
                retailerLimit: {
                    orderName: "BrandName",
                    orderDesc: false
                },
                retailerLimitDetail: {
                    orderName: "CreatedDate",
                    orderDesc: false
                }
            });

            // Retailers
            scope.loadRetailers = function () {
                return http
                    .get("/api/retailer", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        scope.$storage.retailers = response.data;
                    });
            };

            scope.retailerChanged = function (retailer) {
                scope.retailer = retailer;
            };

            scope.$watch("retailer", function () {
                if (typeof scope.retailer !== "undefined") {
                    if (scope.retailer.Id !== scope.$storage.retailer.Id) {
                        if (typeof scope.$storage.shoppingCart !== "undefined" && scope.$storage.shoppingCart.length > 0) {
                            messageBox.showConfirm("ChangeRetailer", "ChangeRetailerEmptyShoppingCartConfirmation", "ChangeRetailer")
                                .result
                                .then(function () {
                                    shoppingCart.empty();
                                    scope.$storage.shoppingCart.number = null;
                                    scope.$storage.retailer = scope.retailer;
                                }, function () {
                                    scope.retailer = scope.$storage.retailer;
                                });
                        } else {
                            scope.$storage.retailer = scope.retailer;
                        }
                    }
                }
            }, true);

            // Car info
            scope.carInfoKeyPress = function ($event) {
                if ($event.keyCode === 13) {
                    scope.carInfoSearch();
                }
            };

            scope.carInfoSearch = function (carInfoVin) {
                var newWindow = window.open("/car-info?vin=" + encodeURIComponent(carInfoVin));
                newWindow.focus();

                scope.carInfoVin = null;
            };

            // Print
            scope.print = function () {
                window.print();
            };

            // Check updates
            scope.checkUpdates = function () {
                clearTimeout(scope.checkUpdatesTimeout);
                if (scope.version !== scope.about.Version) {
                    modal
                        .open({
                            template: require("./VersionUpdate.html"),
                            controller: "VersionUpdateController",
                            resolve: {
                                current: function () {
                                    return scope.version;
                                },
                                available: function () {
                                    return scope.about.Version;
                                }
                            }
                        })
                        .result
                        .then(function () {
                            window.location.reload();
                        }, function () {
                            window.location.reload();
                        });
                }
                scope.checkUpdatesTimeout = setTimeout(scope.loadAbout, 900000);
            };

            // About
            scope.loadAbout = function () {
                return http
                    .get("/api/about")
                    .then(function (response) {
                        scope.about = response.data;
                        if (scope.about.Mode === "Production") {
                            scope.pageTitle = "ROGER";
                        } else if (scope.about.Mode === "Test") {
                            scope.pageTitle = "ROGER UAT";
                        } else if (scope.about.Mode === "Development") {
                            scope.pageTitle = "ROGER DEV";
                        }
                        scope.checkUpdates();
                    });
            };

            // On load
            scope.loadAbout();

            //Logout
            scope.logout = function () {
                scope.$storage.retailer = _retailer;
                window.location.href = scope.getlogoutUrl("Roger");
            };

            scope.getlogoutUrl = function (appName) {

                let baseUrl = __ROGER__.auth.authority;
                let returnUrlParam = encodeURIComponent(location.origin + "?signagain=true");
                return baseUrl + "Sign-out?appName=" + appName + "&returnUrl=" + returnUrlParam;
            }
            // User
            scope.loadUser = function () {
                //

                if (
                    !scope.$storage.user.Id ||
                    scope.$storage.user.Id == -1 ||
                    !scope.$storage.retailer.Id ||
                    scope.$storage.retailer.Id == -1
                ) {
                    // Get user data
                    http
                        .get("/api/user/current", {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            if (response.data.hasOwnProperty("Id")) {
                                scope.$storage.user.Id = response.data.Id;
                                scope.$storage.user.Retailer = response.data.Retailer;
                                scope.$storage.retailer = response.data.Retailer;
                                scope.retailer = scope.$storage.retailer;
                            }
                        }, function () { });
                } else {
                    scope.retailer = scope.$storage.retailer;
                }

                scope.user = user;

                if (user.isOnBehalfOfDealers && (typeof scope.$storage.retailers === "undefined" || scope.$storage.retailers.length === 0)) {
                    scope.loadRetailers();
                }
            };

            rootScope.$on(EVENT_USERAUTHENTICATED, function () {
                //
                console.log(EVENT_USERAUTHENTICATED);
                //
                scope.loadUser();
            });

            rootScope.$on(EVENT_USERCHANGED, function () {
                //
                console.log(EVENT_USERCHANGED);
                //
                scope.loadUser();
            });
        }
    ]);